export default __webpack_public_path__ + "static/media/Req_Med.2f5a5610.svg";